import { withOtpMessage } from '@heyjob-dash/shared/utils/otp-error';

import apiClient from './ApiService';

const data = (request) => request.then((response) => response.data);
const received = (id) => `/company/${id}/onboarding/studio-documents/received`;
const OnboardingService = {
  received: (id) => data(apiClient.get(received(id))),
  receivedPreview: (id, docId, input) => data(apiClient.post(`${received(id)}/${docId}/preview`, { input }, { responseType: 'blob' })),
  complete: (id, docId, input) => data(apiClient.post(`${received(id)}/${docId}/complete`, { input })),
  receivedFile: (id, docId) => data(apiClient.get(`${received(id)}/${docId}/file`)),
  initReceivedSignature: (id, docId) => data(apiClient.post(`${received(id)}/${docId}/signature/init`, {})),
  // Risposta HTTP completa: il pannello OTP condiviso legge `res.data.success`.
  executeReceivedSignature: (id, sessionId, otp) => withOtpMessage(apiClient.post(`${received(id)}/signature/execute`, { sessionId, otp })),
  collection: (id) => data(apiClient.get(`/company/${id}/onboarding/collection`)),
  access: (id) => data(apiClient.post(`/company/${id}/onboarding/access`, {})),
  upload: (id, kind, requestId, file) => {
    const body = new FormData();
    body.append('kind', kind);
    body.append('requestId', requestId);
    body.append('file', file);
    return data(apiClient.post(`/company/${id}/onboarding/documents`, body));
  },
  download: (id, attachmentId) => data(apiClient.get(`/company/${id}/onboarding/documents/${attachmentId}`)),
};
export default OnboardingService;
